import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { BaseColumnComponent } from '../../../../record/services/base-column-component';
import { DownloadRow, DownloadTarget } from '../../../entities/download-row.entity';
import { DownloadsSandboxService } from '../../../sandbox/downloads-sandbox.service';

@Component({
    standalone: false,
    selector: 'digihaven-download-action-cell',
    templateUrl: './download-action-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadActionCellComponent extends BaseColumnComponent<DownloadRow> {
    readonly target$: Observable<DownloadTarget | null>;

    constructor(
        private readonly sandbox: DownloadsSandboxService,
        cd: ChangeDetectorRef
    ) {
        super(cd);

        this.target$ = this.data$.pipe(switchMap(row => row.download$));
    }

    download(target: DownloadTarget): void {
        target.files.forEach(file => this.sandbox.downloadUrl(file.url, file.filename));
    }
}
